import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import { TextInput } from '../BaseComponents';

const ColorPicker = (props: WidgetProps) => {
    const { schema, value, onChange } = props;
    const [color, setColor] = useState(value || '');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setColor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div id="color-picker-container">
            <label id="color-picker-label">{schema.title}</label>
            <div className="color-picker-input">
                <input
                    type="color"
                    className="color-picker"
                    value={color}
                    onChange={handleInputChange}
                />
                <TextInput value={color} onChange={handleInputChange} inputId={'color-value'} />
            </div>
        </div>
    );
};

export default ColorPicker;
